import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { environment } from '../../../environments/environment';
import { MatProgressBar } from '@angular/material/progress-bar';

@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [CommonModule, MatProgressBar],
})
export class LoaderComponent {
  @Input() isFullscreen = false;
  @Input() showVersion = true;
  @Input() loadingText?: string;
  version = environment.version;
}
